import { semantic } from "../semantic/semantic";

export const treetable = {
  root: {
    transitionDuration: "{transition.duration}",
    borderColor: "{surface.border}",
  },
  header: {
    background: "{content.background}",
    borderColor: "{treetable.border.color}",
    color: "{content.color}",
    borderWidth: "0 0 {border.width.1} 0",
    padding: "{padding.16}",
  },
  headerCell: {
    background: "{content.background}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{primary.background}",
    borderColor: "{treetable.border.color}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{content.hover.color}",
    gap: "0",
    padding: "{padding.10} {padding.16}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}",
    },
  },
  columnTitle: {
    fontWeight: "{typography.table.heading.font.weight}",
  },
  row: {
    background: "{content.background}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{content.hover.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{content.hover.color}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}",
    },
  },
  bodyCell: {
    borderColor: "{treetable.border.color}",
    padding: "{treetable.header.cell.padding}",
    selectedBorderColor: "{treetable.border.color}",
    gap: "0",
  },
  footerCell: {
    background: "{content.background}",
    borderColor: "{treetable.border.color}",
    color: "{content.color}",
    padding: "{treetable.header.cell.padding}",
  },
  columnFooter: {
    fontWeight: "{column.title.font.weight}",
  },
  footer: {
    background: "{content.background}",
    borderColor: "{treetable.border.color}",
    color: "{content.color}",
    borderWidth: "{border.width.1}",
    padding: "{padding.16}",
  },
  // columnResizer: {
  //   width: "0.5rem",
  // },
  // resizeIndicator: {
  //   width: "1px",
  //   color: "{primary.color}",
  // },
  sortIcon: {
    color: "{color.neutral.500}",
    hoverColor: "{primary.support}",
    size: "12px",
  },
  // loadingIcon: {
  //   size: "2rem",
  // },
  nodeToggleButton: {
    hoverBackground: "transparent",
    selectedHoverBackground: "transparent",
    color: "{button.ui.secondary.icon.color}",
    hoverColor: "{button.ui.secondary.icon.color}",
    selectedHoverColor: "{button.ui.secondary.icon.color}",
    size: "1.75rem",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
  },
  paginatorTop: {
    borderColor: "{treetable.border.color}",
    borderWidth: "0 0 {border.width.1} 0",
  },
  paginatorBottom: {
    borderColor: "{treetable.border.color}",
    borderWidth: "0 0 {border.width.1} 0",
  },
  extend: {
    ui: {
      headerCell: {
        fontSize: "{typography.table.heading.font.size}",
        fontLeading: "{typography.table.heading.font.leading}",
        mobileFontSize: "{typography.mobile.table.heading.font.size}",
        mobileFontLeading: "{typography.mobile.table.heading.font.leading}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-treetable-thead > tr > th {
      font-size: ${dt("treetable.ui.header.cell.font.size")};
      line-height: ${dt("treetable.ui.header.cell.font.leading")};
      hyphens: auto;
    }

    .p-treetable-tbody > tr > td {
      hyphens: auto;
    }

    .p-treetable-sort-icon .p-sortable-column-icon {
      height: ${dt("treetable.sort.icon.size")};
      width: auto;
    }

    .p-treetable-paginator-top {
      border-color: ${dt("treetable.paginator.top.border.color")};
      border-style: solid;
      border-width: ${dt("treetable.paginator.top.border.width")};
    }

    .p-treetable-paginator-bottom {
      border-color: ${dt("treetable.paginator.bottom.border.color")};
      border-style: solid;
      border-width: ${dt("treetable.paginator.bottom.border.width")};
    }

    .p-treetable-flex-scrollable .p-treetable-scrollable-wrapper, .p-treetable-flex-scrollable .p-treetable-scrollable-view {
      overflow: hidden;
    }

    /* PrimeNG sets overflow-y: scroll (inline style) when scrollHeight is truthy,
       making the vertical scrollbar track always visible. Override to auto so it
       only appears when content actually overflows vertically. */
    .p-treetable-flex-scrollable .p-treetable-scrollable-body {
      overflow-y: auto !important;
    }

    .p-treetable-tbody > tr > td:has(.ui-emptystate) {
      border-width: 0;
    }

    @media (width < ${semantic.breakpoint.mobile}) {
      .p-treetable-thead > tr > th {
        font-size: ${dt("treetable.ui.header.cell.mobile.font.size")};
        line-height: ${dt("treetable.ui.header.cell.mobile.font.leading")};
        white-space: nowrap;
      }

      .p-treetable .p-paginator {
        justify-content: space-between;
      }

      .p-treetable .p-paginator-first,
      .p-treetable .p-paginator-last {
        display: none;
      }
    }
  `,
};
